import MarkCheckIn from "../../../assets/dashboard/Mark_Check_In.svg";
import MarkNoShow from "../../../assets/dashboard/Mark_No_Show.svg";
import Cancel from "../../../assets/dashboard/Cancel.svg";
import Reschedule from "../../../assets/dashboard/Reschedule.svg";
import start_consultation from "../../../assets/dashboard/start_consultation.svg";
import end_consultation from "../../../assets/dashboard/end_consultation.svg";
import create_prescription from "../../../assets/dashboard/create_prescription.svg";
import view_prescription from "../../../assets/dashboard/view_prescription.svg";
import edit_prescription from "../../../assets/dashboard/edit_prescription.svg";
import share_receipt from "../../../assets/dashboard/share_receipt.svg";
import edit_receipt from "../../../assets/dashboard/edit_receipt.svg";
import raise_invoice from "../../../assets/dashboard/raise_invoice.svg";
import share_patient_education from "../../../assets/dashboard/share_patient_education.svg";
import view_receipt from "../../../assets/dashboard/view_receipt.svg";
import view_documents from "../../../assets/dashboard/view_documents.svg";
import view_details from "../../../assets/dashboard/view_details.svg";
import VideoIcon from "../../../assets/video_call_black_24dp.svg";
import vitals_icon from "../../../assets/dashboard/vitals_icon.svg";
import call_next from "../../../assets/dashboard/call_next.svg";
import add_booking from "../../../assets/dashboard/addBookingIcon.svg";
import moment from "moment";
import {
  APPLICABLE_ACCOUNT_TYPE,
  APPLICABLE_ROLE,
  APPLICABLE_SUB_ROLE,
} from "../Constant";
import { LOCALSTORAGEKEY } from "../../../Util/Helper/localStorageUtils";

export const ACTION_TYPES = {
  START_CONSULTATION: "Start Consultation",
  END_CONSULTATION: "End Consultation",
  MARK_CHECK_IN: "Mark Check In",
  MARK_NO_SHOW: "Mark No Show",
  CALL_NEXT: "Call Next",
  ADD_VITALS: "Add Vitals",
  EDIT_VITALS: "Edit Vitals",
  VIEW_VITALS: "View Vitals",
  JOIN_CALL: "Join Call",
  RESCHEDULE: "Reschedule",
  CANCEL: "Cancel",
  RAISE_INVOICE: "Raise Invoice",
  CREATE_PRESCRIPTION: "Create Prescription",
  EDIT_PRESCRIPTION: "Edit Prescription",
  UPLOAD_PRESCRIPTION: "Upload Prescription",
  MANAGE_PRESCRIPTION: "Manage Prescription",
  VIEW_PRESCRIPTION: "View Prescription",
  EDIT_RECEIPT: "Edit Receipt",
  SHARE_RECEIPT: "Share Receipt",
  VIEW_RECEIPT: "View Receipt",
  SHARE_PATIENT_EDUCATION: "Share Patient Education Content",
  VIEW_DETAILS: "View Details",
  VIEW_DOCUMENTS: "View Documents",
  END_AND_SCHEDULE_FOLLOW_UP: "End & Schedule Follow-Up",
  SCHEDULE_FOLLOW_UP: "Schedule Follow-up",
  ADD_BOOKING: "Add Booking",
  PRINT_RX_TEMPLATE: "Print Rx Template",
};

const MOBILE_ACTION_TYPES = {
  START_CONSULTATION: "Start Con.",
  END_CONSULTATION: "End Con.",
  MARK_CHECK_IN: "Mark Check-In",
  MARK_NO_SHOW: "Mark No Show",
  CALL_NEXT: "Call Next",
  ADD_VITALS: "Add Vitals",
  EDIT_VITALS: "Edit Vitals",
  VIEW_VITALS: "View Vitals",
  JOIN_CALL: "Join Call",
  RESCHEDULE: "Reschedule",
  CANCEL: "Cancel",
  RAISE_INVOICE: "Raise Invoice",
  CREATE_PRESCRIPTION: "Create Rx",
  EDIT_PRESCRIPTION: "Edit Rx",
  VIEW_PRESCRIPTION: "View Rx",
  UPLOAD_PRESCRIPTION: "Upload Rx",
  MANAGE_PRESCRIPTION: "Manage Rx",
  EDIT_RECEIPT: "Edit Receipt",
  SHARE_RECEIPT: "Share Receipt",
  VIEW_RECEIPT: "View Receipt",
  SHARE_PATIENT_EDUCATION: "Patient Education",
  VIEW_DETAILS: "View Details",
  VIEW_DOCUMENTS: "View Documents",
  END_AND_SCHEDULE_FOLLOW_UP: "End & Schedule Follow-Up",
  SCHEDULE_FOLLOW_UP: "Schedule Follow-up",
  ADD_BOOKING: "Add Booking",
  PRINT_RX_TEMPLATE: "Print Rx",
};

const APPLICABLE_DAY = {
  PREVIOUS: "previous",
  CURRENT: "current",
  FUTURE: "future",
};

export const APPLICABLE_TYPE = {
  INCLINIC: "in-clinic",
  ONLINE: "online",
  INSTANT: "instant",
  TELE_CONSULT: "tele-consult",
};

export const APPLICABLE_STATUS = {
  CONFIRMED: "confirmed",
  CHECKED_IN: "checked in",
  IN_PROGRESS: "in progress",
  COMPLETED: "completed",
  CANCELLED: "cancelled",
  NO_SHOW: "no show",
};

const actionOptions = [
  {
    type: ACTION_TYPES.END_AND_SCHEDULE_FOLLOW_UP,
    img: raise_invoice,
    label: ACTION_TYPES.END_AND_SCHEDULE_FOLLOW_UP,
    mobileLabel: MOBILE_ACTION_TYPES.END_AND_SCHEDULE_FOLLOW_UP,
    applicableDays: [APPLICABLE_DAY.PREVIOUS, APPLICABLE_DAY.CURRENT],
    applicableTypes: [APPLICABLE_TYPE.INCLINIC],
    applicableStatus: [APPLICABLE_STATUS.IN_PROGRESS],
    applicableRoles: [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF],
    applicableAccountType: [APPLICABLE_ACCOUNT_TYPE.DOCTOR],
  },
  {
    type: ACTION_TYPES.SCHEDULE_FOLLOW_UP,
    img: raise_invoice,
    label: ACTION_TYPES.SCHEDULE_FOLLOW_UP,
    mobileLabel: MOBILE_ACTION_TYPES.SCHEDULE_FOLLOW_UP,
    applicableDays: [APPLICABLE_DAY.PREVIOUS, APPLICABLE_DAY.CURRENT],
    applicableTypes: [APPLICABLE_TYPE.INCLINIC],
    applicableStatus: [APPLICABLE_STATUS.COMPLETED],
    applicableRoles: [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF],
    applicableAccountType: [APPLICABLE_ACCOUNT_TYPE.DOCTOR],
  },
  {
    type: ACTION_TYPES.START_CONSULTATION,
    img: start_consultation,
    label: ACTION_TYPES.START_CONSULTATION,
    mobileLabel: MOBILE_ACTION_TYPES.START_CONSULTATION,
    applicableDays: [APPLICABLE_DAY.CURRENT],
    applicableTypes: [APPLICABLE_TYPE.INCLINIC],
    applicableStatus: [APPLICABLE_STATUS.CHECKED_IN],
    applicableRoles: [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF],
    applicableAccountType: [
      APPLICABLE_ACCOUNT_TYPE.DOCTOR,
      APPLICABLE_ACCOUNT_TYPE.RESOURCE,
    ],
  },
  {
    type: ACTION_TYPES.END_CONSULTATION,
    img: end_consultation,
    label: ACTION_TYPES.END_CONSULTATION,
    mobileLabel: MOBILE_ACTION_TYPES.END_CONSULTATION,
    applicableDays: [APPLICABLE_DAY.CURRENT],
    applicableTypes: [APPLICABLE_TYPE.INCLINIC],
    applicableStatus: [APPLICABLE_STATUS.IN_PROGRESS],
    applicableRoles: [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF],
    applicableAccountType: [
      APPLICABLE_ACCOUNT_TYPE.DOCTOR,
      APPLICABLE_ACCOUNT_TYPE.RESOURCE,
    ],
  },
  {
    type: ACTION_TYPES.MARK_CHECK_IN,
    img: MarkCheckIn,
    label: ACTION_TYPES.MARK_CHECK_IN,
    mobileLabel: MOBILE_ACTION_TYPES.MARK_CHECK_IN,
    applicableDays: [APPLICABLE_DAY.CURRENT],
    applicableTypes: [APPLICABLE_TYPE.INCLINIC],
    applicableStatus: [APPLICABLE_STATUS.CONFIRMED, APPLICABLE_STATUS.NO_SHOW],
    applicableRoles: [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF],
    applicableAccountType: [
      APPLICABLE_ACCOUNT_TYPE.DOCTOR,
      APPLICABLE_ACCOUNT_TYPE.RESOURCE,
    ],
  },
  {
    type: ACTION_TYPES.JOIN_CALL,
    img: VideoIcon,
    label: ACTION_TYPES.JOIN_CALL,
    mobileLabel: MOBILE_ACTION_TYPES.JOIN_CALL,
    applicableDays: [APPLICABLE_DAY.CURRENT],
    applicableTypes: [APPLICABLE_TYPE.ONLINE],
    applicableStatus: [
      APPLICABLE_STATUS.CONFIRMED,
      APPLICABLE_STATUS.IN_PROGRESS,
    ],
    applicableRoles: [APPLICABLE_ROLE.DOCTOR],
    applicableAccountType: [APPLICABLE_ACCOUNT_TYPE.DOCTOR],
  },
  {
    type: ACTION_TYPES.CALL_NEXT,
    img: call_next,
    label: ACTION_TYPES.CALL_NEXT,
    mobileLabel: MOBILE_ACTION_TYPES.CALL_NEXT,
    applicableDays: [APPLICABLE_DAY.CURRENT],
    applicableTypes: [APPLICABLE_TYPE.INCLINIC],
    applicableStatus: [APPLICABLE_STATUS.IN_PROGRESS],
    applicableRoles: [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF],
    applicableAccountType: [
      APPLICABLE_ACCOUNT_TYPE.DOCTOR,
      APPLICABLE_ACCOUNT_TYPE.RESOURCE,
    ],
  },
  {
    type: ACTION_TYPES.ADD_VITALS,
    img: vitals_icon,
    label: ACTION_TYPES.ADD_VITALS,
    mobileLabel: MOBILE_ACTION_TYPES.ADD_VITALS,
    applicableStatus: [
      APPLICABLE_STATUS.CONFIRMED,
      APPLICABLE_STATUS.CHECKED_IN,
      APPLICABLE_STATUS.IN_PROGRESS,
    ],
    applicableRoles: [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF],
    applicableAccountType: [APPLICABLE_ACCOUNT_TYPE.DOCTOR],
  },
  {
    type: ACTION_TYPES.EDIT_VITALS,
    img: vitals_icon,
    label: ACTION_TYPES.EDIT_VITALS,
    mobileLabel: MOBILE_ACTION_TYPES.EDIT_VITALS,
    applicableStatus: [
      APPLICABLE_STATUS.CONFIRMED,
      APPLICABLE_STATUS.CHECKED_IN,
      APPLICABLE_STATUS.IN_PROGRESS,
    ],
    applicableRoles: [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF],
    applicableAccountType: [APPLICABLE_ACCOUNT_TYPE.DOCTOR],
  },
  {
    type: ACTION_TYPES.VIEW_VITALS,
    img: vitals_icon,
    label: ACTION_TYPES.VIEW_VITALS,
    mobileLabel: MOBILE_ACTION_TYPES.VIEW_VITALS,
    applicableRoles: [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF],
    applicableAccountType: [APPLICABLE_ACCOUNT_TYPE.DOCTOR],
  },
  {
    type: ACTION_TYPES.MARK_NO_SHOW,
    img: MarkNoShow,
    label: ACTION_TYPES.MARK_NO_SHOW,
    mobileLabel: MOBILE_ACTION_TYPES.MARK_NO_SHOW,
    applicableDays: [APPLICABLE_DAY.CURRENT],
    applicableTypes: [APPLICABLE_TYPE.INCLINIC],
    applicableStatus: [
      APPLICABLE_STATUS.CONFIRMED,
      APPLICABLE_STATUS.CHECKED_IN,
    ],
    applicableRoles: [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF],
    applicableAccountType: [
      APPLICABLE_ACCOUNT_TYPE.DOCTOR,
      APPLICABLE_ACCOUNT_TYPE.RESOURCE,
    ],
  },
  {
    type: ACTION_TYPES.RESCHEDULE,
    img: Reschedule,
    label: ACTION_TYPES.RESCHEDULE,
    mobileLabel: MOBILE_ACTION_TYPES.RESCHEDULE,
    applicableDays: [APPLICABLE_DAY.CURRENT, APPLICABLE_DAY.FUTURE],
    applicableTypes: [APPLICABLE_TYPE.INCLINIC, APPLICABLE_TYPE.ONLINE],
    applicableStatus: [APPLICABLE_STATUS.CONFIRMED],
    applicableRoles: [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF],
    applicableAccountType: [
      APPLICABLE_ACCOUNT_TYPE.DOCTOR,
      APPLICABLE_ACCOUNT_TYPE.RESOURCE,
    ],
  },
  {
    type: ACTION_TYPES.RAISE_INVOICE,
    img: raise_invoice,
    label: ACTION_TYPES.RAISE_INVOICE,
    mobileLabel: MOBILE_ACTION_TYPES.RAISE_INVOICE,
    applicableDays: [
      APPLICABLE_DAY.PREVIOUS,
      APPLICABLE_DAY.CURRENT,
      APPLICABLE_DAY.FUTURE,
    ],
    applicableTypes: [APPLICABLE_TYPE.INCLINIC],
    applicableStatus: [
      APPLICABLE_STATUS.CONFIRMED,
      APPLICABLE_STATUS.CHECKED_IN,
      APPLICABLE_STATUS.IN_PROGRESS,
      APPLICABLE_STATUS.COMPLETED,
    ],
    applicableRoles: [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF],
    applicableAccountType: [
      APPLICABLE_ACCOUNT_TYPE.DOCTOR,
      APPLICABLE_ACCOUNT_TYPE.RESOURCE,
    ],
  },
  {
    type: ACTION_TYPES.CREATE_PRESCRIPTION,
    img: create_prescription,
    label: ACTION_TYPES.CREATE_PRESCRIPTION,
    mobileLabel: MOBILE_ACTION_TYPES.CREATE_PRESCRIPTION,
    applicableDays: [APPLICABLE_DAY.CURRENT],
    applicableTypes: [APPLICABLE_TYPE.INCLINIC, APPLICABLE_TYPE.ONLINE],
    applicableStatus: [
      APPLICABLE_STATUS.IN_PROGRESS,
      APPLICABLE_STATUS.COMPLETED,
    ],
    applicableRoles: [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF],
    applicableAccountType: [APPLICABLE_ACCOUNT_TYPE.DOCTOR],
  },
  {
    type: ACTION_TYPES.EDIT_PRESCRIPTION,
    img: edit_prescription,
    label: ACTION_TYPES.EDIT_PRESCRIPTION,
    mobileLabel: MOBILE_ACTION_TYPES.EDIT_PRESCRIPTION,
    applicableRoles: [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF],
    applicableAccountType: [APPLICABLE_ACCOUNT_TYPE.DOCTOR],
  },
  {
    type: ACTION_TYPES.VIEW_PRESCRIPTION,
    img: view_prescription,
    label: ACTION_TYPES.VIEW_PRESCRIPTION,
    mobileLabel: MOBILE_ACTION_TYPES.VIEW_PRESCRIPTION,
    applicableRoles: [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF],
    applicableAccountType: [APPLICABLE_ACCOUNT_TYPE.DOCTOR],
  },
  {
    type: ACTION_TYPES.PRINT_RX_TEMPLATE,
    img: view_prescription,
    label: ACTION_TYPES.PRINT_RX_TEMPLATE,
    mobileLabel: MOBILE_ACTION_TYPES.PRINT_RX_TEMPLATE,
    applicableTypes: [APPLICABLE_TYPE.INCLINIC],
    applicableStatus: [
      APPLICABLE_STATUS.CONFIRMED,
      APPLICABLE_STATUS.CHECKED_IN,
      APPLICABLE_STATUS.IN_PROGRESS,
      APPLICABLE_STATUS.COMPLETED,
    ],
    applicableRoles: [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF],
    applicableAccountType: [APPLICABLE_ACCOUNT_TYPE.DOCTOR],
  },
  {
    type: ACTION_TYPES.EDIT_RECEIPT,
    img: edit_receipt,
    label: ACTION_TYPES.EDIT_RECEIPT,
    mobileLabel: MOBILE_ACTION_TYPES.EDIT_RECEIPT,
    applicableDays: [
      APPLICABLE_DAY.PREVIOUS,
      APPLICABLE_DAY.CURRENT,
      APPLICABLE_DAY.FUTURE,
    ],
    applicableTypes: [APPLICABLE_TYPE.INCLINIC],
    applicableStatus: [
      APPLICABLE_STATUS.CONFIRMED,
      APPLICABLE_STATUS.CHECKED_IN,
      APPLICABLE_STATUS.IN_PROGRESS,
      APPLICABLE_STATUS.COMPLETED,
    ],
    applicableRoles: [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF],
    applicableAccountType: [
      APPLICABLE_ACCOUNT_TYPE.DOCTOR,
      APPLICABLE_ACCOUNT_TYPE.RESOURCE,
    ],
  },
  {
    type: ACTION_TYPES.SHARE_RECEIPT,
    img: share_receipt,
    label: ACTION_TYPES.SHARE_RECEIPT,
    mobileLabel: MOBILE_ACTION_TYPES.SHARE_RECEIPT,
    applicableRoles: [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF],
    applicableStatus: [
      APPLICABLE_STATUS.CONFIRMED,
      APPLICABLE_STATUS.CHECKED_IN,
      APPLICABLE_STATUS.IN_PROGRESS,
      APPLICABLE_STATUS.COMPLETED,
    ],
    applicableAccountType: [
      APPLICABLE_ACCOUNT_TYPE.DOCTOR,
      APPLICABLE_ACCOUNT_TYPE.RESOURCE,
    ],
  },
  {
    type: ACTION_TYPES.VIEW_RECEIPT,
    img: view_receipt,
    label: ACTION_TYPES.VIEW_RECEIPT,
    mobileLabel: MOBILE_ACTION_TYPES.VIEW_RECEIPT,
    applicableRoles: [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF],
    applicableStatus: [
      APPLICABLE_STATUS.CONFIRMED,
      APPLICABLE_STATUS.CHECKED_IN,
      APPLICABLE_STATUS.IN_PROGRESS,
      APPLICABLE_STATUS.COMPLETED,
    ],
    applicableAccountType: [
      APPLICABLE_ACCOUNT_TYPE.DOCTOR,
      APPLICABLE_ACCOUNT_TYPE.RESOURCE,
    ],
  },
  {
    type: ACTION_TYPES.CANCEL,
    img: Cancel,
    label: ACTION_TYPES.CANCEL,
    mobileLabel: MOBILE_ACTION_TYPES.CANCEL,
    applicableDays: [
      APPLICABLE_DAY.PREVIOUS,
      APPLICABLE_DAY.CURRENT,
      APPLICABLE_DAY.FUTURE,
    ],
    applicableTypes: [APPLICABLE_TYPE.INCLINIC, APPLICABLE_TYPE.ONLINE],
    applicableStatus: [
      APPLICABLE_STATUS.CONFIRMED,
      APPLICABLE_STATUS.CHECKED_IN,
    ],
    applicableRoles: [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF],
    applicableAccountType: [
      APPLICABLE_ACCOUNT_TYPE.DOCTOR,
      APPLICABLE_ACCOUNT_TYPE.RESOURCE,
    ],
  },
  {
    type: ACTION_TYPES.SHARE_PATIENT_EDUCATION,
    img: share_patient_education,
    label: ACTION_TYPES.SHARE_PATIENT_EDUCATION,
    mobileLabel: MOBILE_ACTION_TYPES.SHARE_PATIENT_EDUCATION,
    applicableDays: [APPLICABLE_DAY.PREVIOUS, APPLICABLE_DAY.CURRENT],
    applicableTypes: [APPLICABLE_TYPE.INCLINIC, APPLICABLE_TYPE.ONLINE],
    applicableStatus: [APPLICABLE_STATUS.COMPLETED],
    applicableRoles: [APPLICABLE_ROLE.DOCTOR],
    applicableAccountType: [APPLICABLE_ACCOUNT_TYPE.DOCTOR],
  },
  {
    type: ACTION_TYPES.ADD_BOOKING,
    img: add_booking,
    label: ACTION_TYPES.ADD_BOOKING,
    mobileLabel: MOBILE_ACTION_TYPES.ADD_BOOKING,
    applicableDays: [APPLICABLE_DAY.CURRENT],
    applicableTypes: [APPLICABLE_TYPE.INCLINIC],
    applicableStatus: [
      APPLICABLE_STATUS.CONFIRMED,
      APPLICABLE_STATUS.CHECKED_IN,
      APPLICABLE_STATUS.IN_PROGRESS,
      APPLICABLE_STATUS.COMPLETED,
    ],
    applicableRoles: [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF],
    applicableAccountType: [
      APPLICABLE_ACCOUNT_TYPE.DOCTOR,
      APPLICABLE_ACCOUNT_TYPE.RESOURCE,
    ],
  },
  {
    type: ACTION_TYPES.VIEW_DETAILS,
    img: view_details,
    label: ACTION_TYPES.VIEW_DETAILS,
    mobileLabel: MOBILE_ACTION_TYPES.VIEW_DETAILS,
  },
  {
    type: ACTION_TYPES.VIEW_DOCUMENTS,
    img: view_documents,
    label: ACTION_TYPES.VIEW_DOCUMENTS,
    mobileLabel: MOBILE_ACTION_TYPES.VIEW_DOCUMENTS,
  },
];

export const filteredOptions = (
  appnt,
  user_type,
  user_id,
  isCheckedInAppnts
) => {
  let day = "future";
  if (
    moment(appnt.appointment_date).format("YYYY-MM-DD") ===
    moment().format("YYYY-MM-DD")
  ) {
    day = "current";
  } else if (
    moment(appnt.appointment_date).format("YYYY-MM-DD") <
    moment().format("YYYY-MM-DD")
  ) {
    day = "previous";
  }

  let userType = user_type;

  let arr = [],
    opt;
  actionOptions.forEach((option) => {
    switch (option.type) {
      case ACTION_TYPES.START_CONSULTATION:
      case ACTION_TYPES.END_CONSULTATION:
      case ACTION_TYPES.MARK_NO_SHOW:
      case ACTION_TYPES.SCHEDULE_FOLLOW_UP:
        if (displayAction(appnt, day, option, userType)) {
          arr.push(option);
        }
        break;
      case ACTION_TYPES.END_AND_SCHEDULE_FOLLOW_UP:
        if (displayInprogressAction(appnt, day, option, userType)) {
          arr.push(option);
        }
        break;

      case ACTION_TYPES.CALL_NEXT:
        if (
          displayCallNextAction(appnt, day, option, userType, isCheckedInAppnts)
        ) {
          arr.push(option);
        }
        break;
      case ACTION_TYPES.RESCHEDULE:
      case ACTION_TYPES.CANCEL:
        if (displayRescheduleCancelAction(appnt, day, option, userType)) {
          arr.push(option);
        }
        break;
      case ACTION_TYPES.MARK_CHECK_IN:
        if (displayMarkCheckInAction(appnt, day, option, userType)) {
          arr.push(option);
        }
        break;
      case ACTION_TYPES.RAISE_INVOICE:
        if (displayReceiptInvoice(appnt, day, option, userType)) {
          arr.push(option);
        }
        break;
      case ACTION_TYPES.EDIT_RECEIPT:
        opt = editReceiptInvoice(appnt, day, option, userType);
        if (opt) {
          arr.push(opt);
        }
        break;
      case ACTION_TYPES.SHARE_RECEIPT:
      case ACTION_TYPES.VIEW_RECEIPT:
        if (shareReceiptInvoice(appnt, option, userType)) {
          arr.push(option);
        }
        break;
      case ACTION_TYPES.CREATE_PRESCRIPTION:
        opt = displayCreateRx(appnt, option, userType, user_id);
        if (opt) {
          arr.push(opt);
        }
        break;
      case ACTION_TYPES.EDIT_PRESCRIPTION:
        opt = displayEditRx(appnt, option, userType, user_id);
        if (opt) {
          arr.push(opt);
        }
        break;
      case ACTION_TYPES.VIEW_PRESCRIPTION:
        if (displayViewRx(appnt, option, userType)) {
          arr.push(option);
        }
        break;
      case ACTION_TYPES.PRINT_RX_TEMPLATE:
        if (displayPrintRx(appnt, option, userType)) {
          arr.push(option);
        }
        break;
      case ACTION_TYPES.SHARE_PATIENT_EDUCATION:
      case ACTION_TYPES.JOIN_CALL:
        if (
          displayDoctorSpecificAction(appnt, day, option, userType, user_id)
        ) {
          arr.push(option);
        }
        break;
      case ACTION_TYPES.ADD_VITALS:
        if (displayAddVitals(appnt, option, userType)) {
          arr.push(option);
        }
        break;
      case ACTION_TYPES.EDIT_VITALS:
        if (displayEditVitals(appnt, option, userType)) {
          arr.push(option);
        }
        break;
      case ACTION_TYPES.VIEW_VITALS:
        if (displayViewVitals(appnt, option, userType)) {
          arr.push(option);
        }
        break;
      case ACTION_TYPES.ADD_BOOKING:
        if (displayAddBooking(appnt, day, option, userType)) {
          arr.push(option);
        }
        break;
      default:
        arr.push(option);
        break;
    }
  });
  return arr;
};

const displayCreateRx = (appnt, option, userType, user_id) => {
  const endTime = moment(
    appnt.appointment_journey_time.consultation_ended.consultation_ended_time
  ).add(48, "hours");
  const editButtonStatus = moment().isAfter(endTime);
  let display = false;
  if (
    option.applicableTypes.includes(appnt.appointment_type) &&
    option.applicableStatus.includes(appnt.appointment_status.toLowerCase()) &&
    option.applicableRoles.includes(userType) &&
    option.applicableAccountType.includes(+appnt.account_type) &&
    appnt.prescription_notification_sent.toLowerCase() === "false" &&
    appnt.manual_rx_notification_sent.toLowerCase() === "false" &&
    appnt.prescription_status === "" &&
    (userType === APPLICABLE_ROLE.DOCTOR
      ? appnt.doctor_id === user_id
      : true) &&
    !editButtonStatus
  ) {
    display = {
      ...option,
      label:
        userType === APPLICABLE_ROLE.DOCTOR
          ? ACTION_TYPES.CREATE_PRESCRIPTION
          : ACTION_TYPES.UPLOAD_PRESCRIPTION,
      mobileLabel:
        userType === APPLICABLE_ROLE.DOCTOR
          ? MOBILE_ACTION_TYPES.CREATE_PRESCRIPTION
          : MOBILE_ACTION_TYPES.UPLOAD_PRESCRIPTION,
    };
  }
  return display;
};

const displayEditRx = (appnt, option, userType, user_id) => {
  const endTime = moment(
    appnt?.appointment_journey_time?.consultation_ended?.consultation_ended_time
  ).add(48, "hours");

  const editButtonStatus = moment().isAfter(endTime);
  let display = false;
  if (
    option.applicableRoles.includes(userType) &&
    option.applicableAccountType.includes(+appnt.account_type) &&
    (appnt.prescription_notification_sent.toLowerCase() === "true" ||
      appnt.manual_rx_notification_sent.toLowerCase() === "true" ||
      appnt.prescription_status === "edited" ||
      appnt.prescription_status === "created" ||
      appnt.prescription_status === "shared") &&
    (userType === APPLICABLE_ROLE.DOCTOR
      ? appnt.doctor_id === user_id
      : true) &&
    !editButtonStatus
  ) {
    display = {
      ...option,
      label:
        userType === APPLICABLE_ROLE.DOCTOR
          ? ACTION_TYPES.EDIT_PRESCRIPTION
          : ACTION_TYPES.MANAGE_PRESCRIPTION,
      mobileLabel:
        userType === APPLICABLE_ROLE.DOCTOR
          ? MOBILE_ACTION_TYPES.EDIT_PRESCRIPTION
          : MOBILE_ACTION_TYPES.MANAGE_PRESCRIPTION,
      expiryTime:
        appnt?.appointment_status?.toLowerCase() ===
        APPLICABLE_STATUS.IN_PROGRESS
          ? null
          : endTime,
    };
  }
  return display;
};

const displayViewRx = (appnt, option, userType) => {
  const endTime = moment(
    appnt.appointment_journey_time.consultation_ended.consultation_ended_time
  ).add(48, "hours");
  const editButtonStatus = moment().isAfter(endTime);
  let display = false;
  if (
    option.applicableRoles.includes(userType) &&
    option.applicableAccountType.includes(+appnt.account_type) &&
    (appnt.prescription_notification_sent.toLowerCase() === "true" ||
      appnt.manual_rx_notification_sent.toLowerCase() === "true" ||
      (userType === "staff"
        ? appnt.prescription_status === "shared"
          ? true
          : false
        : appnt.prescription_status === "created" && true)) &&
    editButtonStatus
  ) {
    display = true;
  }
  return display;
};

const displayPrintRx = (appnt, option, userType) => {
  let endedTime =
    appnt.appointment_journey_time.consultation_ended.consultation_ended_time;
  const endTime = moment(endedTime).add(48, "hours");
  const editButtonStatus = endedTime ? moment().isAfter(endTime) : false;
  let display = false;
  if (
    option.applicableTypes.includes(appnt.appointment_type) &&
    option.applicableStatus.includes(appnt.appointment_status.toLowerCase()) &&
    option.applicableRoles.includes(userType) &&
    option.applicableAccountType.includes(+appnt.account_type) &&
    !editButtonStatus
  ) {
    display = true;
  }
  return display;
};

//invoice applicable days, user type, status, invoice raise time

const displayReceiptInvoice = (appnt, day, option, userType) => {
  let receiptButtonStatus = false;
  let display = false;
  let consultation_ended_time =
    appnt?.account_type == 1
      ? appnt.order_completed_time
      : appnt.appointment_journey_time.consultation_ended
          .consultation_ended_time;

  if (+appnt.pending_amount === 0 && consultation_ended_time) {
    let timer = consultation_ended_time;
    if (appnt.last_transaction_time) {
      timer = new Date(
        Math.max(
          new Date(consultation_ended_time),
          new Date(appnt.last_transaction_time)
        )
      );
    }
    let endTime = moment(timer).add(48, "hours");
    receiptButtonStatus = moment().isAfter(endTime);
  }

  if (
    displayAction(appnt, day, option, userType) &&
    (!appnt.appointment_journey_time.invoice_raised.invoice_raised_time ||
      appnt.appointment_journey_time.invoice_raised.invoice_raised_by.toLowerCase() ===
        "system") &&
    !receiptButtonStatus
  ) {
    display = true;
  }
  return display;
};

const editReceiptInvoice = (appnt, day, option, userType) => {
  let receiptButtonStatus = false;
  let endTime = null;
  let display = false;
  let consultation_ended_time =
    appnt?.account_type == 1
      ? appnt.order_completed_time
      : appnt.appointment_journey_time.consultation_ended
          .consultation_ended_time;

  if (+appnt.pending_amount === 0 && consultation_ended_time) {
    let timer = consultation_ended_time;
    if (appnt.last_transaction_time) {
      timer = new Date(
        Math.max(
          new Date(consultation_ended_time),
          new Date(appnt.last_transaction_time)
        )
      );
    }
    endTime = moment(timer).add(48, "hours");
    receiptButtonStatus = moment().isAfter(endTime);
  }

  if (
    displayAction(appnt, day, option, userType) &&
    appnt.appointment_journey_time.invoice_raised.invoice_raised_time &&
    appnt.appointment_journey_time.invoice_raised.invoice_raised_by.toLowerCase() !==
      "system" &&
    !receiptButtonStatus
  ) {
    display = {
      ...option,
      expiryTime: endTime,
    };
  }
  return display;
};

const shareReceiptInvoice = (appnt, option, userType) => {
  let display = false;
  if (
    option.applicableRoles.includes(userType) &&
    option.applicableAccountType.includes(+appnt.account_type) &&
    option.applicableStatus.includes(appnt.appointment_status.toLowerCase()) &&
    (appnt.appointment_journey_time.invoice_raised.invoice_raised_time ||
      appnt.consultation_type.toLowerCase().includes(APPLICABLE_TYPE.INSTANT) ||
      appnt.consultation_type
        .toLowerCase()
        .includes(APPLICABLE_TYPE.TELE_CONSULT))
  ) {
    display = true;
  }
  return display;
};

const displayMarkCheckInAction = (appnt, day, option, userType) => {
  let display = false;
  if (displayAction(appnt, day, option, userType)) {
    if (appnt.appointment_status.toLowerCase() === APPLICABLE_STATUS.NO_SHOW) {
      if (appnt.appointment_payment_method !== APPLICABLE_TYPE.ONLINE) {
        display = true;
      }
    } else {
      display = true;
    }
  }
  return display;
};

const displayRescheduleCancelAction = (appnt, day, option, userType) => {
  let display = false;
  if (
    displayAction(appnt, day, option, userType) &&
    !appnt.consultation_type.toLowerCase().includes(APPLICABLE_TYPE.INSTANT)
  ) {
    display = true;
  }
  return display;
};

const displayAction = (appnt, day, option, userType) => {
  let display = false;
  if (
    option.applicableDays.includes(day) &&
    option.applicableTypes.includes(appnt.appointment_type) &&
    option.applicableStatus.includes(appnt.appointment_status.toLowerCase()) &&
    option.applicableRoles.includes(userType) &&
    option.applicableAccountType.includes(+appnt.account_type)
  ) {
    display = true;
  }
  return display;
};

const displayCallNextAction = (
  appnt,
  day,
  option,
  userType,
  isCheckedInAppnts
) => {
  let display = false;

  if (
    displayAction(appnt, day, option, userType) &&
    isCheckedInAppnts.includes(appnt.doctor_id)
  ) {
    display = true;
  }
  return display;
};

//status action for schedule follow-up option.
const displayInprogressAction = (appnt, day, option, userType) => {
  let display = false;
  if (
    displayAction(appnt, day, option, userType) &&
    appnt.follow_up_date === null
  ) {
    display = true;
  }
  return display;
};

const displayDoctorSpecificAction = (appnt, day, option, userType, user_id) => {
  let display = false;
  if (
    displayAction(appnt, day, option, userType) &&
    appnt.doctor_id === user_id
  ) {
    display = true;
  }
  return display;
};

const displayAddVitals = (appnt, option, userType) => {
  let display = false;
  if (
    option.applicableStatus.includes(appnt.appointment_status.toLowerCase()) &&
    option.applicableRoles.includes(userType) &&
    option.applicableAccountType.includes(+appnt.account_type) &&
    !appnt.vitals_exists &&
    appnt.prescription_status.toLowerCase() !== "shared"
  ) {
    display = true;
  }
  return display;
};

const displayEditVitals = (appnt, option, userType) => {
  let display = false;
  if (
    option.applicableStatus.includes(appnt.appointment_status.toLowerCase()) &&
    option.applicableRoles.includes(userType) &&
    option.applicableAccountType.includes(+appnt.account_type) &&
    appnt.vitals_exists &&
    appnt.prescription_status.toLowerCase() !== "shared"
  ) {
    display = true;
  }
  return display;
};

const displayViewVitals = (appnt, option, userType) => {
  let display = false;
  if (
    (appnt.appointment_status.toLowerCase() === APPLICABLE_STATUS.COMPLETED ||
      appnt.prescription_status.toLowerCase() === "shared") &&
    option.applicableRoles.includes(userType) &&
    option.applicableAccountType.includes(+appnt.account_type)
  ) {
    display = true;
  }
  return display;
};

const displayAddBooking = (appnt, day, option, userType) => {
  let display = false;
  let is_clinic_and_lab = JSON.parse(
    localStorage.getItem(LOCALSTORAGEKEY.IS_CLINIC_AND_LAB)
  );
  let clinic_id = localStorage.getItem(LOCALSTORAGEKEY.CLINIC_ID);
  let userRole = localStorage.getItem(LOCALSTORAGEKEY.DOCTOR_ROLE);
  if (
    option.applicableDays.includes(day) &&
    option.applicableTypes.includes(appnt.appointment_type) &&
    option.applicableStatus.includes(appnt.appointment_status.toLowerCase()) &&
    option.applicableAccountType.includes(+appnt.account_type) &&
    clinic_id &&
    is_clinic_and_lab &&
    ((userType === APPLICABLE_ROLE.DOCTOR &&
      userRole === APPLICABLE_SUB_ROLE.DOCTORADMIN) ||
      userType === APPLICABLE_ROLE.STAFF)
  ) {
    display = true;
  }
  return display;
};
